module.exports = __webpack_public_path__ + "static/img/broad_bottom@3x.bd0de708.png";